import useCampaign from '@hooks/useCampaign'
import useOrders from '@hooks/useOrders'
import useOrderItems from '@hooks/useOrderItems'
import useProvider from '@hooks/useProvider'

import type { CampaignModel, ProviderModel } from '@models/types'

interface UseMediaReviewerParams {
  campaign: Partial<CampaignModel>,
  provider: Partial<ProviderModel>,
}

const useMediaReviewer = (params: UseMediaReviewerParams) => {
  const { campaign: initCampaign, provider: initProvider } = params

  const campaignPayload = useCampaign(initCampaign, {
    performHttpRequests: !!initCampaign?.id,
    requestOptions: {
      include_campaign_image: true,
    },
  })

  const {
    campaign,
    loading: loadingCampaign,
  } = campaignPayload

  const providerPayload = useProvider(initProvider, {
    performHttpRequests: !!initProvider?.id,
    requestOptions: {
      include_provider_logo: true,
    },
  })

  const {
    loading: loadingProvider,
    logoUrl: providerLogoUrl,
    provider,
  } = providerPayload

  const { loading: loadingOrders } = useOrders({
    filters: {
      campaign_id: initCampaign?.id,
      provider_id: initProvider?.id,
    },
    performHttpRequests: !!initCampaign?.id && !!initProvider?.id,
    requestOptions: {
      allow_provider_orders: true,
      include_attachment_file: true,
      include_order_item_attachments: true,
      include_order_item_due_date: true,
      include_order_item_service: true,
      include_order_items: true,
    },
  })

  const { filteredOrderItems } = useOrderItems({
    filters: {
      campaign_id: initCampaign?.id,
      provider_id: initProvider?.id,
    },
    sortBy: 'id asc',
  })

  return {
    campaign,
    filteredOrderItems,
    loadingCampaign,
    loadingOrders,
    loadingProvider,
    provider,
    providerLogoUrl,
  }
}

export default useMediaReviewer
